// Console desk: Today, Calendar, bookings list, booking drawer, walk-in.
// Keys are the Arabic source strings (what the Arabic UI shows); values are English.
// Strings that already exist in the prototype catalog (en.ts) need no entry here.
export const consoleDeskEn: Readonly<Record<string, string>> = {
  // Today
  'مساء الخير،': 'Good evening,',
  '{n} مع الزبائن': '{n} with customers',
  'يحتاج انتباهك': 'Needs your attention',
  '{n} تنبيه': '{n} alerts',
  'السيارة {plate} لم تعد بعد': 'Car {plate} is not back yet',
  'الحجز {ref} يستلمها {time}، وهي مع الحجز {out} الذي كان موعد إرجاعه {due}.':
    'Booking {ref} picks it up {time}; it is still out with booking {out}, which was due back {due}.',
  'استلام متأخر: {name}': 'Late return: {name}',
  '{car} كان موعد إرجاعها {due} · الحجز {ref}': '{car} was due back {due} · booking {ref}',
  'تم التسليم': 'Handed over',
  'تم الاستلام': 'Returned',
  'تأخر عن الموعد': 'Past pickup time',
  '{n} دقيقة': '{n} min',
  '{n} ساعة': '{n} h',
  '{d} يوم و{h} ساعة': '{d} d {h} h',
  // Road status
  'حالة الطريق': 'Road status',
  الطريق: 'Road',
  'نقطة التفتيش': 'Checkpoint',
  مفتوح: 'Open',
  بحذر: 'Caution',
  مغلق: 'Closed',
  'ملاحظة بالعربية': 'Note in Arabic',
  'ملاحظة بالإنجليزية': 'Note in English',
  'تظهر للزبائن في موقع الحجز': 'Shown to customers on the booking site',
  'تم تحديث حالة الطريق': 'Road status updated',
  تعديل: 'Edit',
  حفظ: 'Save',
  'إعادة المحاولة': 'Try again',
  // Calendar & bookings list
  'بانتظار الدفع': 'Awaiting payment',
  'انتهت المهلة': 'Expired',
  'خارج الخدمة': 'Out of service',
  'مفتاح الألوان': 'Legend',
  'الفترة السابقة': 'Previous period',
  'الفترة التالية': 'Next period',
  'مدة العرض': 'Range',
  أسبوع: 'Week',
  أسبوعان: 'Two weeks',
  'لا توجد سيارات لعرضها': 'No cars to show',
  'استخدم الأسهم للتنقل بين الحجوزات، و Enter لفتح التفاصيل.':
    'Use the arrow keys to move between bookings and Enter to open one.',
  'تغيير إطارات': 'Tyre change',
  'فحص دوري': 'Inspection',
  إصلاح: 'Repair',
  'البحث في كل الحجوزات': 'Search all bookings',
  'لا توجد حجوزات قادمة': 'No upcoming bookings',
  إجراءات: 'Actions',
  'تحميل المزيد': 'Load more',
  'ابحث بالاسم أو الهاتف أو رقم الحجز': 'Search by name, phone or booking number',
  'تصفية الحجوزات': 'Filter bookings',
  بحث: 'Search',
  'اسم الزبون أو الهاتف أو رقم الحجز': 'Customer name, phone or booking number',
  المصدر: 'Source',
  'من تاريخ': 'From',
  'إلى تاريخ': 'To',
  الترتيب: 'Order',
  'الأقرب أولاً': 'Soonest first',
  'الأحدث أولاً': 'Latest first',
  'مسح التصفية': 'Clear filters',
  'لا توجد حجوزات تطابق البحث': 'No bookings match the search',
  'لا توجد حجوزات بعد': 'No bookings yet',
  'أول {n} حجز': 'First {n} bookings',
  '{n} حجز': '{n} bookings',
  // Drawer
  'لم نجد هذا الحجز': "We couldn't find this booking",
  'لا تملك صلاحية عرض هذا الحجز': "You don't have permission to view this booking",
  'جارٍ التحديث…': 'Updating…',
  'ملف الزبون': 'Customer profile',
  'متبقٍ {d} يوم و{h} ساعة على الاستلام': '{d} d {h} h left until pickup',
  'آخر موعد للطلب': 'last day to ask',
  'تغيير السيارة': 'Change car',
  'أقسام الحجز': 'Booking sections',
  الدفعات: 'Payments',
  الفواتير: 'Invoices',
  الرسائل: 'Messages',
  'شامل ضريبة القيمة المضافة': 'VAT included',
  'خطة الدفع': 'Payment plan',
  'كامل المبلغ': 'Full amount',
  'رصيد الزبون': 'Customer credit',
  أنشأه: 'Created by',
  'سجل الحجز': 'Booking history',
  أُنشئ: 'Created',
  'بانتظار الدفع حتى': 'Payment hold until',
  تأكّد: 'Confirmed',
  'سُلّمت السيارة': 'Car handed over',
  'استُلمت السيارة': 'Car returned',
  'حُوّل إلى رصيد': 'Converted to credit',
  أُلغي: 'Cancelled',
  // Schedule change
  'اختر موعداً جديداً لترى السعر والسيارة.': 'Pick a new time to see the price and the car.',
  'الموعد الحالي': 'Current',
  'الموعد الجديد': 'New',
  'السيارة الحالية غير متاحة في هذا الموعد، سينتقل الحجز إلى {plate}.':
    'The current car is not free at this time; the booking will move to {plate}.',
  'فرق السعر': 'Price difference',
  'المتبقي يُحصَّل عند التسليم': 'Balance collected at handover',
  'يُضاف إلى رصيد الزبون': "Added to the customer's credit",
  'مدفوع زيادة': 'Overpaid',
  'حُدّثت بيانات الحجز. راجع الموعد ثم احفظ مجدداً.':
    'The booking was updated. Check the time and save again.',
  'تم تعديل الموعد': 'Time changed',
  'تم تعديل الموعد ونقل الحجز إلى السيارة {plate}': 'Time changed and the booking moved to {plate}',
  'انتهت ساعات الاستلام لهذا اليوم، اختر تاريخاً لاحقاً':
    'Pickup hours are over for today; choose a later date',
  // Reassign
  'سيارة أخرى من نفس الطراز للموعد نفسه. السعر لا يتغير.':
    'Another car of the same model for the same time. The price stays the same.',
  'لا توجد سيارة أخرى من هذا الطراز': 'There is no other car of this model',
  'متاحة في هذا الموعد': 'Free at this time',
  'محجوزة للحجز {ref}': 'Booked for {ref}',
  'في الصيانة في هذا الموعد': 'In maintenance at this time',
  'نقل الحجز': 'Move booking',
  'نُقل الحجز إلى السيارة {plate}': 'Booking moved to {plate}',
  // Credit & cancel
  'ملاحظة (اختياري)': 'Note (optional)',
  'أُضيف {amount} إلى رصيد الزبون': "{amount} added to the customer's credit",
  'للحالات الاستثنائية مثل عدم الحضور. الزبون لا يحصل على رصيد، والمدفوعات تبقى كما هي.':
    'For exceptional cases such as a no-show. The customer gets no credit, and payments are kept.',
  'ملاحظة (مطلوبة لسبب «أخرى»)': 'Note (required for "Other")',
  'أُلغي الحجز {ref}': 'Booking {ref} cancelled',
  // Submitted details
  'ما أدخله الزبون عند الحجز': 'What was entered with the booking',
  'زائر الموقع بدون تسجيل دخول': 'Website visitor, not signed in',
  'الزبون بعد تسجيل الدخول': 'The customer, signed in',
  'الموظف عند المكتب': 'Staff at the desk',
  النظام: 'System',
  'لم يُحدَّث ملف الزبون بهذه البيانات': "the customer's profile was not updated with these details",
  'يختلف عن الملف': 'Differs from profile',
  'مطابق للملف': 'Matches profile',
  'لا يطابق الملف': 'Does not match profile',
  'صورة البطاقة المدنية': 'Civil ID photo',
  'صورة الرخصة': 'Licence photo',
  حُذفت: 'deleted',
  'لم تُرفق مستندات مع الحجز': 'No documents were sent with the booking',
  'تعذّر فتح المستند': "Couldn't open the document",
  // Messages
  'في الانتظار': 'Queued',
  'قيد الإرسال': 'Sending',
  أُرسلت: 'Sent',
  وصلت: 'Delivered',
  قُرئت: 'Read',
  'فشل الإرسال': 'Failed',
  'تذكير بموعد الاستلام': 'Pickup reminder',
  'تذكير بموعد الاستلام اليوم': 'Pickup reminder (today)',
  'استلام دفعة': 'Payment received',
  'استلام طلب التحويل إلى رصيد': 'Credit request received',
  'رفض طلب الرصيد': 'Credit request rejected',
  'ملخص الاستلام': 'Return summary',
  'دعوة موظف': 'Staff invite',
  'رمز التحقق': 'Verification code',
  'لم تُرسل رسائل لهذا الحجز بعد': 'No messages sent for this booking yet',
  '{n} محاولات': '{n} attempts',
  'نص الرسالة': 'Message text',
  'إعادة الإرسال': 'Send again',
  'أُعيدت الرسالة إلى قائمة الإرسال': 'The message is queued again',
  'تعذّر إعادة الإرسال': "Couldn't send it again",
  // Walk-in
  'بدء من جديد': 'Start over',
  'بيانات الحجز': 'Booking details',
  'ابحث عن زبون سابق بالاسم أو الهاتف': 'Find a returning customer by name or phone',
  'زبائن مطابقون': 'Matching customers',
  'جارٍ البحث…': 'Searching…',
  'لا يوجد زبون بهذا الاسم أو الرقم، أكمل كزبون جديد':
    'No customer with this name or number; continue as a new customer',
  'زبون سابق': 'Returning customer',
  '{n} حجوزات سابقة': '{n} past bookings',
  'زبون جديد': 'New customer',
  اختياري: 'Optional',
  'لغة رسائل واتساب': 'WhatsApp language',
  المستندات: 'Documents',
  'البطاقة المدنية': 'Civil ID',
  'صورة أو PDF، تُحفظ في ملف الزبون': "Photo or PDF, kept in the customer's profile",
  'رفع صورة': 'Upload photo',
  'جارٍ الرفع': 'Uploading',
  'تم الرفع': 'Uploaded',
  'اختيار ملف آخر': 'Choose another file',
  'إلغاء الرفع': 'Cancel upload',
  إزالة: 'Remove',
  'طريقة الدفع': 'Payment method',
  'تظهر للفريق في تفاصيل الحجز': 'Shown to the team in the booking details',
  'اختر السيارة والموعد لحساب المبلغ.': 'Choose the car and time to price it.',
  'خصم الباقة': 'Bundle discount',
  'ضريبة القيمة المضافة': 'VAT',
  'شامل ضريبة القيمة المضافة {rate}:': 'Includes VAT {rate}:',
  'يُحصَّل الآن': 'Collect now',
  'سيارات متاحة من هذا الطراز:': 'Cars free of this model:',
  'راجع الحقول المظللة في النموذج': 'Check the highlighted fields in the form',
  'تم إنشاء الحجز {ref}': 'Booking {ref} created',
  'فتح الحجز': 'Open booking',
  'حجز حضوري آخر': 'Another walk-in',
  'أدخل اسم الزبون': "Enter the customer's name",
  'أدخل رقم هاتف صحيحاً': 'Enter a valid phone number',
  'الرقم المدني مطلوب': 'The civil number is required',
  'على ملف الزبون، اكتبه فقط إن تغيّر': "On the customer's file; type it only if it changed",
  'الرقم المدني هو نفسه رقم رخصة القيادة': 'The civil number is also the driving licence number',
  'انتظر اكتمال رفع المستندات': 'Wait for the documents to finish uploading',
  'كود الخصم غير صالح': 'This promo code is not valid',
  'كود الخصم غير مفعّل': 'This promo code is not active',
  'كود الخصم لم يبدأ بعد': "This promo code hasn't started yet",
  'انتهت صلاحية كود الخصم': 'This promo code has expired',
  'انتهت استخدامات كود الخصم': 'This promo code has been used up',
  'استخدم الزبون هذا الكود من قبل': 'The customer has already used this code',
  'هذا اليوم مغلق للحجز': 'This day is closed for bookings',
  'أُزيلت وفق قاعدة مدة الحفظ': 'removed under the retention rule',
};
